import React, { useRef, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import './PhotoCarousel.scss';

function PhotoCarousel({ isTouchScreen }) {
  const captions = [
    '1. First-time buyers are more likely to purchase in small towns and rural areas than in urban centers.',
    '2. Young buyers are more likely to buy a fixer-upper property that may need DIY improvements.',
    '3. Older buyers are no longer downsizing but choosing to stay in roughly the same size space as their previous home.',
    "4. More families purchased second homes during the pandemic to spend extended periods of time in 'vacation' destinations.",
    '5. Many remote workers are relocating from expensive city centers to more affordable urban areas in the Midwest.'
  ];
  const length = captions.length - 1;
  const [current, setCurrent] = useState(0);
  const photoRef = useRef();

  const handlers = useSwipeable({
    onSwipedLeft: () => handleClick('right'),
    onSwipedRight: () => handleClick('left')
  });

  const handleClick = (direction) => {
    let currentI;
    if (direction === 'right') {
      if (current === length) {
        photoRef.current.style.animation = 'moveTo1R 0.7s ease-in forwards';
      } else {
        photoRef.current.style.animation = `moveTo${current + 2}R 0.7s ease-in forwards`;
      }
      currentI = current === length ? 0 : current + 1;
    } else {
      if (current === 0) {
        photoRef.current.style.animation = 'moveTo6 0.7s ease-in forwards';
      } else {
        photoRef.current.style.animation = `moveTo${current} 0.7s ease-in forwards`;
      }

      currentI = current === 0 ? length : current - 1;
    }
    setCurrent(currentI);
  };
  return (
    <figure className="photoCarousel">
      <div className="photoCarousel-carousel">
        <h3 className="photoCarousel__title">five more insights on what home buyers want now</h3>
        <div className="photoCarousel__photoContainer" {...handlers}>
          <div className="photoCarousel__photoContainer-container" ref={photoRef}>
            {captions.map((photo, i) => {
              return (
                <div key={i} className="current">
                  <div className={`current-photo current-photo-${i}`}></div>
                  <div className="current__captionContainer">
                    <p className="current__captionContainer__caption">{photo}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="indicator">
          <button
            className="nav-button"
            id="backButton"
            onClick={() => {
              handleClick('left');
            }}
          >
            BACK
          </button>
          <p className="nav-divider">|</p>
          <button
            className="nav-button"
            id="nextButton"
            onClick={() => {
              handleClick('right');
            }}
          >
            NEXT
          </button>
        </div>
      </div>
      <figcaption className="captions">
        {current === 3
          ? 'Source: REALTORS® Confidence Index'
          : 'Source: NAR, Profile of Home Buyers and Sellers, 2022'}
      </figcaption>
    </figure>
  );
}

export default PhotoCarousel;
